<template>
  <transition name="bounce">
    <b-container class="py-5 custom-container container">
      <b-breadcrumb
        :items="items"
        class="pl-0 pt-5 mt-5 bg-transparent"
      ></b-breadcrumb>
      <h2 class="font-weight-bold">Edit</h2>
      <b-card class="mt-4">
        <div class="mx-auto p-lg-5 w-75">
          <h4 class="font-weight-bold mb-4">File Details</h4>
          <new-request-form :formType="'edit'" :file-request="request" />
        </div>
      </b-card>
    </b-container>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import NewRequestForm from '@/components/forms/NewRequestForm'

export default {
  name: 'EditRequestedToPage',

  components: {
    NewRequestForm,
  },

  data() {
    return {}
  },

  computed: {
    ...mapGetters('requests', ['request']),

    items() {
      return [
        {
          text: this.request ? `${this.request.name}` : '',
          to: '/request/to/' + this.$route.params.id,
        },
        { text: 'Edit' },
      ]
    },
  },

  methods: {
    ...mapActions({
      getRequest: 'requests/getRequest',
    }),

    async fetchRequest() {
      await this.getRequest(this.$route.params.id)
    },
  },

  async mounted() {
    await this.fetchRequest()
  },
}
</script>
